module.exports = __webpack_public_path__ + "static/media/26_plantilla_navidad_combo_dua_cuadrada_cinta_2_motivo_1.d99ff50a.png";